import { Box } from '@chakra-ui/react'

export function Layout({ children, maxW }) {
  return (
    <Box maxW={maxW ? maxW : window.innerWidth - 100} mx="auto" px="1rem" py="1rem" w="100%">
      {children}
    </Box>
  )
}
